import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppContextState } from ".";

export type AppOrigin = "admin" | "gnt" | "unknown";

const initialState: AppContextState = {
  origin: "unknown",
};

export const slice = createSlice({
  name: "appContext",
  initialState,
  reducers: {
    setOrigin: (state, action: PayloadAction<AppOrigin>) => {
      state.origin = action.payload;
    },
  },
});
